export const ZENDESK_GUIDE_LINK =
  'https://loonainc.zendesk.com/hc/en-us/articles/4405702514962-How-to-gift-Loona-to-a-friend-';
